export default  {
  component: 'inverter',
  name: 'Inverter',
  fields: [
    {
      param: 'plant_id',
      type: 'number',
      required: true,
      identifier: true,
      hidden: true
    },
    {
      name: 'Block ID',
      param: 'block_id',
      type: 'number',
      required: true,
      identifier: true,
      description: `> Should always start from ID **"1"**`
    },
    {
      name: 'Room ID',
      param: 'room_id',
      type: 'number',
      required: true,
      identifier: true,
      description: `> For each block, room id should start from **"1"**`
    },
    {
      name: 'Inverter ID',
      param: 'inverter_id',
      type: 'number',
      required: true,
      identifier: true,
      description: `> For each Block-Room, inverter id should start from **"1"**`
    },
    {
      name: 'Inverter Name',
      param: 'name',
      type: 'text',
      description: `> For each block-room inverter name should be unique`
    },
    {
      name: 'Name Config',
      param: 'name_config',
      type: 'text',
      description: `The name should be unique. Name Concatination of Block Name-Room Name-Device Name`
    },
    {
      name: 'Analytics Name',
      param: 'analytics_name_config',
      type: 'text',
      description: `The name should be unique. Name Concatination of Block Name-Room Name-Device Name`
    },
    {
      name: 'AC Capacity',
      param: 'inverter_ac_capacity',
      type: 'number',
      description: `Its a mandatory data for the calculation of **"PR"**. It should be sum of all the inverters capacities present in that specific Block-Room.`
    },
    {
      name: 'DC Capacity',
      param: 'inverter_dc_capacity',
      type: 'number',
      description: `Its a mandatory data. It should be sum of all the inverters capacities present in that specific room`
    },
    {
      name: 'DC Power Count',
      param: 'dc_power_count',
      type: 'number',
      description: `> Count we display in analytics. By default it should be **"1"**`
    },
    {
      name: 'DC Current Count',
      param: 'dc_current_count',
      type: 'number',
      description: `> Count we display in analytics. By default it should be **"1"**`
    },
    {
      name: 'DC Voltage Count',
      param: 'dc_voltage_count',
      type: 'number',
      description: `> Count we display in analytics. By default it should be **"1"**`
    },
    {
      name: 'Reading Frequency',
      param: 'reading_frequency',
      type: 'number',
      description: `It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
    },
    {
      name: 'LVRT Status',
      param: 'lvrt_status',
      type: 'number',
    },
    {
      name: 'LVRT Percentage',
      param: 'lvrt_percentage',
      type: 'number',
    },
    {
      name: 'Latitude',
      param: 'latitude',
      type: 'number',
      description: `In order to add Map marker in Plantoverview Dashboard - **MAP VIEW**`
    },
    {
      name: 'Longitude',
      param: 'longitude',
      type: 'number',
      description: `In order to add Map marker in Plantoverview Dashboard - **MAP VIEW**`
    },
    {
      name: 'Make',
      param: 'make',
      type: 'text',
    },
    {
      name: 'Irradiance (Ref. device Id)',
      param: 'irr_ref_device_id',
      type: 'number',
      description: `In order to plot **"irradiance(PoA)"** graph in inverter dashboard we need to refer to which ws id PoA data exist.`
    },
    {
      name: 'Irradiance (Ref. block Id)',
      param: 'irr_ref_block_id',
      type: 'number',
      description: `In order to plot **"irradiance(PoA)"** graph in inverter dashboard we need to refer to which block id, the ws id PoA data exist.`
    },
    {
      name: 'Temperature (Ref. device Id)',
      param: 'temp_ref_block_id',
      type: 'number',
      description: `In order to plot **"Temperature"** data in Temp Corrected PR dashboard we need to refer to which block, the devuce id temperature data exist  \*(e.g ERDA[1-1]).`
    },
    {
      name: 'Temperature (Ref. block Id)',
      param: 'temp_ref_device_id',
      type: 'number',
      description: `In order to plot **"Temperature"** data in Temp Corrected PR dashboard we need to refer to which block id temperature data exist  \*(e.g ERDA[1-1]).`
    },
    {
      name: 'Temperature Corrected PR',
      param: 'temp_corrected_pr',
      type: 'boolean',
    },
    {
      name: 'MPPT Count',
      param: 'mppt_count',
      type: 'number',
      description: `If the plant has string inverter the mppt count should be added.`
    },
    {
      name: 'Type',
      param: 'inverter_type',
      type: 'text',
      description:` - If its SCB - inverter type should be **"1"**
      - If its String Inverter/MPPT - inverter type should be **"2"**
      - If its Zone - inverter type should be **"3"**`
    },
    {
      name: 'Param Config',
      param: 'param_config',
      type: 'json',
      description: `If the plant has DC Power and DC Current json needs to be added by default : 
      {"dc_power": {"name": "DC Power", "count": 1, "multiple": false, "nameIndexing": true}, "dc_current": {"name": "DC Current", "count": 1, "multiple": false, "nameIndexing": true}}, if more than 1 DC Power and DC current exists,
      need to change the count and chaange **multiple as true**`
    },
    {
      name: 'Filter Config',
      param: 'filter_config',
      type: 'json',
    },
    {
      name: 'Parameter List',
      param: 'param_list',
      type: 'text',
      description: `In order to remove unwanted parameters from analytics. *\(e.g rm-efficiency,rm-voltage_supply)`
    },
    {
      name: 'Model',
      param: 'model',
      type: 'text',
    },
    {
      name: 'Name',
      param: 'name',
      type: 'text',
      description: `Add concatination names for block-room-device which will be displayed for MPPT data tables`
    }
  ]
}